import Dropzone from 'react-dropzone';

import { Button } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

import CustomIcon from '../CustomIcons';

import './styles/index.css';

const FileUpload = ({
  onDrop,
  requirementMessageOne,
  requirementMessageTwo,
  fileButtonLabel,
  dragFileLabel,
  orLabel,
  acceptedExtensions,
  maxFileSize,
  allowMultipleFiles
}) => (
  <Dropzone
    onDrop={acceptedFiles => onDrop(acceptedFiles)}
    accept={acceptedExtensions}
    maxSize={maxFileSize}
    multiple={allowMultipleFiles}
  >
    {({ getRootProps, getInputProps }) => (
      <section className="file-upload">
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          <div className="file-upload__drop-zone">
            <CustomIcon size="32" type="cloudUpload" className="upload-icon" fill="#666666" />
            <span className="b epsilon">{dragFileLabel}</span>
          </div>
          <div className="file-upload__or-wrapper">
            <div />
            {orLabel}
            <div />
          </div>
          <div className="file-upload__button-wrapper">
            <Button classes="file-upload__button b" dataMetricsLocation="FU">
              {fileButtonLabel}
            </Button>
          </div>
          <div className="file-upload__req-message">
            <span>{requirementMessageOne}</span>
            <span>{requirementMessageTwo}</span>
          </div>
        </div>
      </section>
    )}
  </Dropzone>
);

export default FileUpload;

FileUpload.propTypes = {
  acceptedExtensions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]).isRequired,
  onDrop: PropTypes.func.isRequired,
  requirementMessageOne: PropTypes.string,
  requirementMessageTwo: PropTypes.string,
  fileButtonLabel: PropTypes.string,
  dragFileLabel: PropTypes.string,
  orLabel: PropTypes.string,
  maxFileSize: PropTypes.number,
  allowMultipleFiles: PropTypes.bool
};

FileUpload.defaultProps = {
  requirementMessageOne: 'File type must be a PDF, JPG, PNG, XLS, or DOC.',
  requirementMessageTwo: 'Size must be smaller than 2 MB',
  fileButtonLabel: 'Browse Files',
  dragFileLabel: 'Drag Files to Upload',
  orLabel: 'or',
  maxFileSize: 2000000,
  allowMultipleFiles: true
};
